<lib-dialog-layout-inner-x
  [btnText]="'auth.reset_password' | translate"
  (confirm)="resetPassword()"
  [title]="'auth.reset_password' | translate"
  [disableSubmit]="form?.invalid"
>
  <ng-template #content>
    <lib-reset-password-form (formInstance)="form = $event"></lib-reset-password-form>
  </ng-template>
</lib-dialog-layout-inner-x>
